import React, {HTMLAttributes} from 'react'

interface Props extends HTMLAttributes<HTMLButtonElement> {
 icon?: React.ReactNode
 text?: string
 type?: 'button' | 'submit' | 'reset' | undefined
 disabled?: boolean
 children?: React.ReactNode
}
const Button = ({
 onClick,
 id,
 title,
 className,
 disabled,
 color,
 type = 'button',
 icon,
 text,
 children,
}: Props) => {
 return (
  <>
   <button
    type={type}
    disabled={disabled}
    onClick={onClick}
    id={id}
    data-title={title}
    className={`${className} ${
     disabled && '!bg-[#C5CED6]'
    } border-${color} border-2 github-star font-bold px-3 py-2 outline-none active:bg-${color} hover:bg-${color} focus:bg-${color} shadow 
            flex flex-row items-center justify-center text-center tracking-wide transition-colors duration-200 transform rounded-md  focus:outline-none 
             `}
   >
    {icon}
    <div className='flex items-center'>
     {children}
     {text}
    </div>
   </button>
  </>
 )
}

Button.defaultProps = {
 color: 'rose',
 className: 'w-full',
 disabled: false,
}

export {Button}
